import React, { useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { GiftCertBalanceModalProps } from './GiftCertBalanceModal.types'
import Modal from '@molecules/Modal/Modal'
import Headline from '@atoms/Headline/Headline'
import AlertBox from '@molecules/AlertBox/AlertBox'
import Icons from '@atoms/Icons/Icons'
import Spinner from '@atoms/Spinner/Spinner'
import getGiftCardCheckFields, { messages } from './GiftCardBalanceModal.fields'
import * as T from './GiftCertBalanceModal.types'
import { useBasket } from 'msp-integrations'
import Grid from '@atoms/Grid/Grid'
import Field from '@molecules/Field/Field'
import Button from '@atoms/Button/Button'

const ModalBody = () => {
  const fieldConfig = getGiftCardCheckFields()
  const {
    control,
    errors,
    formState,
    handleSubmit,
    clearErrors,
    setError,
    reset
  } = useForm()
  const basket = useBasket()
  const [currentGiftCert, setCurrentGiftCert] = useState<any>(null)
  const { formatMessage } = useIntl()
  const alertBoxRef = useRef<AlertBox>()

  const onFormSubmit = async (data: T.HandleSubmitProps) => {
    const response = await basket.checkGiftCertificateBalance(
      data.activationCode
    )

    if (response.error) {
      setError('global', {
        type: 'manual',
        message: response.ErrorMsg.replace('{0}', data.activationCode)
      })
      alertBoxRef?.current?.showAlert()
    } else {
      reset({
        activationCode: ''
      })
    }

    setCurrentGiftCert({
      code: response.giftCertID,
      balance: response.balance,
      message: response.BalanceMsg
    })
  }

  return (
    <div>
      <AlertBox
        ref={alertBoxRef}
        description={errors?.global?.message || ''}
        closeButtonIcon={<Icons iconName='Close' size='base' />}
      />
      <form onSubmit={handleSubmit(onFormSubmit)} id={'gift-card-form'}>
        <Grid wrapperStyles='grid-cols-1 md:grid-cols-2 md:gap-2'>
          <Field
            className={'w-full'}
            control={control}
            config={fieldConfig.activationCode}
            error={errors?.activationCode}
            isDisabled={formState.isSubmitting || currentGiftCert}
          />
          <Button
            className='mt-3 w-full md:w-6/12'
            onClick={() => clearErrors()}
            isDisabled={formState.isSubmitting || currentGiftCert}
            isLoading={formState.isSubmitting}
            isSubmit
            loadingContent={<Spinner size='xl' />}
          >
            {formatMessage(messages.button)}
          </Button>
        </Grid>
        {currentGiftCert && (
          <>
            <p>{currentGiftCert.message}</p>
          </>
        )}
      </form>
    </div>
  )
}

const GiftCertBalanceModal = ({
  showModal,
  setShowModal
}: GiftCertBalanceModalProps) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      overlay
      closeOnOverlayClick
      blockScroll
      modalHeader={
        <Headline tag='h6'>
          {formatMessage({
            id: 'msp.gift_cert.modal.headline',
            defaultMessage: 'Check balance of your Gift Card'
          })}
        </Headline>
      }
      modalBody={<ModalBody />}
    />
  )
}

export default GiftCertBalanceModal
